import Xmark from '@ui-components-3/icons/lib/duotone/HexagonXmark'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { useDialogHeaderIdDirty } from 'hoc/withDialog'

type DialogHeaderProps = {
  title: string
  titleTestId?: string
  closeButtonTestId?: string
  onClose?: () => void
  className?: string
  id?: string
}

const DialogHeader = ({ title, titleTestId, closeButtonTestId, onClose, className, id }: DialogHeaderProps) => {
  const defaultId = useDialogHeaderIdDirty()

  return (
    <div
      className={classNames(
        'mx-2 my-1 flex items-center justify-between rounded-lg bg-neutral-100 px-2 py-1.5 sm:px-4 sm:py-3 md:mx-6 md:my-4',
        className,
      )}
    >
      <h2 className="typography-h5 text-neutral-800" data-testid={titleTestId} id={id ?? defaultId}>
        {title}
      </h2>
      {!!onClose && (
        <button
          className="btn-small btn-neutral-borderless ml-2 h-[24px] w-[24px] min-w-0 shrink-0 px-0"
          type="button"
          onClick={onClose}
          data-testid={closeButtonTestId}
        >
          <Xmark className="h-[24px] w-[24px]" aria-label="Close" />
        </button>
      )}
    </div>
  )
}

export default DialogHeader
